"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.twitter = exports.fachgebiet = exports.medium = exports.status = exports.birthdate = exports.cf_nlarte = exports.cf_acceptTOS = exports.birthdateYear = exports.birthdateMonth = exports.birthdateDay = exports.country = exports.city = exports.zipCode = exports.street = exports.firstName = exports.lastName = exports.gender = exports.maxBirthDateYear = exports.minBirthDateYear = exports.twitterMaxCharacters = exports.fachgebietMaxCharacters = exports.mediumMaxCharacters = exports.statusMaxCharacters = exports.countryMaxCharacters = exports.cityMaxCharacters = exports.zipCodeMaxCharacters = exports.streetMaxCharacters = exports.nameMaxCharacters = exports.confirmEmail = exports.email = exports.emailMaxCharacters = exports.oldpassword = exports.confirmnewpassword = exports.newpassword = exports.confirmpassword = exports.password = exports.birthdateYearMax = exports.birthdateYearMin = exports.passwordMaxCharacters = exports.passwordMinCharacters = exports.createSchema = void 0;
var yup_1 = require("yup");
// eslint-disable-next-line
var createSchema = function (params) {
    var shape = (0, yup_1.object)().shape(__assign(__assign({}, params), { APIError: (0, yup_1.boolean)().default(false) }));
    return shape;
};
exports.createSchema = createSchema;
exports.passwordMinCharacters = 6;
exports.passwordMaxCharacters = 32;
exports.birthdateYearMin = 1920;
exports.birthdateYearMax = 2009;
exports.password = (0, yup_1.string)()
    .required()
    .min(exports.passwordMinCharacters)
    .max(exports.passwordMaxCharacters);
exports.confirmpassword = (0, yup_1.string)().required().test({
    name: 'password.confirm',
    test: function () {
        var _a = this.parent, password = _a.password, confirmpassword = _a.confirmpassword;
        return password && confirmpassword === password;
    },
});
exports.newpassword = exports.password;
exports.confirmnewpassword = (0, yup_1.string)().required().test({
    name: 'password.confirm',
    test: function () {
        var _a = this.parent, newpassword = _a.newpassword, confirmnewpassword = _a.confirmnewpassword;
        return newpassword && confirmnewpassword === newpassword;
    },
});
exports.oldpassword = (0, yup_1.string)().required();
exports.emailMaxCharacters = 320;
exports.email = (0, yup_1.string)().required().email().max(exports.emailMaxCharacters).trim();
exports.confirmEmail = (0, yup_1.string)().required().test({
    name: 'email.confirm',
    test: function () {
        var _a = this.parent, email = _a.email, confirmEmail = _a.confirmEmail;
        return email && confirmEmail === email;
    },
});
exports.nameMaxCharacters = 256;
exports.streetMaxCharacters = 512;
exports.zipCodeMaxCharacters = 128;
exports.cityMaxCharacters = 256;
exports.countryMaxCharacters = 128;
// presse
exports.statusMaxCharacters = 128;
exports.mediumMaxCharacters = 128;
exports.fachgebietMaxCharacters = 128;
exports.twitterMaxCharacters = 1024;
exports.minBirthDateYear = new Date().getUTCFullYear() - 110;
exports.maxBirthDateYear = new Date().getUTCFullYear() - 10;
exports.gender = (0, yup_1.mixed)().oneOf(['m', 'f', 'u']).optional();
exports.lastName = (0, yup_1.string)().max(exports.nameMaxCharacters).optional();
exports.firstName = (0, yup_1.string)().max(exports.nameMaxCharacters).optional();
exports.street = (0, yup_1.string)().max(exports.streetMaxCharacters).optional();
exports.zipCode = (0, yup_1.string)().max(exports.zipCodeMaxCharacters).optional();
exports.city = (0, yup_1.string)().max(exports.cityMaxCharacters).optional();
exports.country = (0, yup_1.string)().max(exports.countryMaxCharacters).optional();
exports.birthdateDay = (0, yup_1.number)().max(31).optional();
exports.birthdateMonth = (0, yup_1.number)().max(12).optional();
exports.birthdateYear = (0, yup_1.number)().min(exports.birthdateYearMin).max(exports.birthdateYearMax).optional();
exports.cf_acceptTOS = (0, yup_1.bool)().required().default(false).isTrue();
exports.cf_nlarte = (0, yup_1.bool)().default(false);
exports.birthdate = (0, yup_1.date)().min(new Date(exports.minBirthDateYear, 0, 1)).max(new Date(exports.maxBirthDateYear, 11, 31));
// presse
exports.status = (0, yup_1.string)().max(exports.statusMaxCharacters).optional();
exports.medium = (0, yup_1.string)().max(exports.mediumMaxCharacters).optional();
exports.fachgebiet = (0, yup_1.string)().max(exports.fachgebietMaxCharacters).optional();
exports.twitter = (0, yup_1.string)().max(exports.twitterMaxCharacters).optional();
